/**
 * @name 대시보드
 * @description
 */
import styled from 'styled-components'
import {App} from 'template'
import {Panel} from 'components'
// contents
import {Header} from './common'
import {Table} from './contents'

export default function Presenter() {
  return (
    <App>
      <Content className="container-height">
        <Panel header={<Header />}>
          {/* 테이블영역 */}
          <Table />
        </Panel>
      </Content>
    </App>
  )
}
//*--------------------------------------------------*
const Content = styled.div``
